// extracted by mini-css-extract-plugin
export const websites = "Apps-module--websites--KBmIX";
export const header = "Apps-module--header--lYS-n";
export const designed = "Apps-module--designed--1L-Su";
export const feature_title = "Apps-module--feature_title--1Wvlk";
export const websites_img = "Apps-module--websites_img--2-Ucm";
export const websites_feature = "Apps-module--websites_feature--s6GXE";
export const bouncy = "Apps-module--bouncy--26Et4";
export const pop = "Apps-module--pop--3S5JD";